import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import Login from './pages/Login.jsx';
import ResetContrasenya from './pages/ResetContrasenya.jsx';
import Enquestador from './pages/Enquestador.jsx';
import AppMain from './pages/AppMain.jsx';
import Enquesta from './pages/Enquesta.jsx';
import NouComerc from './pages/NouComerc.jsx';

export default function Root() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/reset/:token" element={<ResetContrasenya />} />
        <Route path="/enquestador" element={<Enquestador />} />
        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <AppMain />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/formularis/nou"
          element={
            <ProtectedRoute>
              <NouComerc />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/formularis/:id"
          element={
            <ProtectedRoute>
              <Enquesta />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
